__turbopack_context__.v({
  "avatarBlurred": "CandidateCardLight-module__0Ctq8q__avatarBlurred",
  "avatarFallback": "CandidateCardLight-module__0Ctq8q__avatarFallback",
  "avatarImage": "CandidateCardLight-module__0Ctq8q__avatarImage",
  "avatarPanel": "CandidateCardLight-module__0Ctq8q__avatarPanel",
  "avatarWrapper": "CandidateCardLight-module__0Ctq8q__avatarWrapper",
  "bottom": "CandidateCardLight-module__0Ctq8q__bottom",
  "card": "CandidateCardLight-module__0Ctq8q__card",
  "cta": "CandidateCardLight-module__0Ctq8q__cta",
  "ctaIcon": "CandidateCardLight-module__0Ctq8q__ctaIcon",
  "headings": "CandidateCardLight-module__0Ctq8q__headings",
  "highlights": "CandidateCardLight-module__0Ctq8q__highlights",
  "meta": "CandidateCardLight-module__0Ctq8q__meta",
  "metaSeparator": "CandidateCardLight-module__0Ctq8q__metaSeparator",
  "moreSkills": "CandidateCardLight-module__0Ctq8q__moreSkills",
  "name": "CandidateCardLight-module__0Ctq8q__name",
  "recruiterLogo": "CandidateCardLight-module__0Ctq8q__recruiterLogo",
  "recruiterLogoPlaceholder": "CandidateCardLight-module__0Ctq8q__recruiterLogoPlaceholder",
  "root": "CandidateCardLight-module__0Ctq8q__root",
  "skill": "CandidateCardLight-module__0Ctq8q__skill",
  "skillEmoji": "CandidateCardLight-module__0Ctq8q__skillEmoji",
  "skillLogo": "CandidateCardLight-module__0Ctq8q__skillLogo",
  "skillsLabel": "CandidateCardLight-module__0Ctq8q__skillsLabel",
  "skillsList": "CandidateCardLight-module__0Ctq8q__skillsList",
  "skillsPanel": "CandidateCardLight-module__0Ctq8q__skillsPanel",
  "title": "CandidateCardLight-module__0Ctq8q__title",
  "top": "CandidateCardLight-module__0Ctq8q__top",
});
